import radium from 'radium';
import EventData from "./EventData";
import EventTickets from "./EventTickets";
import SectionTitleSimple from "../../../components/sectionTitle/SectionTitleSimple";
import ZigZagBox from "../../../components/zig-zag-box/ZigZagBox";
import ShoppingCartSubTotal from "./ShoppingCartSubTotal";
import ZigZagBoxTitle from "../../../components/zig-zag-boxTitle/ZigZagBoxTitle";

function ShoppingCartEventOverview(props) {
	const style = {
		scEvent: {
			margin: '2.5em 0 .5em'
		}
	}
	return (
		<div>
			<ZigZagBox>
				<ZigZagBoxTitle headlineLevel={"h2"}>
					Warenkorb
				</ZigZagBoxTitle>
			{props.shoppingCartEvents.map((event, index) => (
				<div key={index.toString()} style={style.scEvent}>
					<SectionTitleSimple headlineLevel={"h3"}>
						<EventData
							title={event.event}
							subtitle={event.eventSubtitle}
							date={event.eventBegin}
							location={`${event.venue}, ${event.locationPostalCode} ${event.locationCity}`}
						/>
					</SectionTitleSimple>

					<EventTickets tickets={event.displayTickets} />
				</div>
			))}
				<ShoppingCartSubTotal subTotal={props.subTotal}/>
			</ZigZagBox>
		</div>
	);
}

export default radium(ShoppingCartEventOverview);
